import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

//Leads
import Processo from "./leads/processo/reducer"
import Publicacao from "./leads/publicacao/reducer"
import Lead from "./leads/lead/reducer"
import Apolice from "./leads/apolice/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"
import ResetPassword from "./auth/resetpwd/reducer"

// Users
import contacts from "./contacts/reducer"

//Dasboard saas
import DashboardSaas from "./dashboard-saas/reducer";

const rootReducer = combineReducers({
  // public
  Processo,
  Publicacao,
  Lead,
  Apolice,
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  DashboardSaas,
  ResetPassword,
  contacts
})

export default rootReducer
